import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

const audiences = [
  {
    n: "01",
    label: "Private investors",
    body: "A discreet ecosystem for HNW individuals seeking clarity, privacy, and global control over banking and investments.",
  },
  {
    n: "02",
    label: "Family offices",
    body: "Multi-account governance, granular permissions, and consolidated reporting across mandates and asset classes.",
  },
  {
    n: "03",
    label: "Institutional partners",
    body: "Direct access to investment mandates, structured opportunities, and a dedicated relationship desk.",
  },
];

export default function Audiences() {
  return (
    <section
      id="audiences"
      className="relative bg-[#0A0B0D] py-32 sm:py-40 lg:py-48 border-t border-[#1F2126]"
      data-testid="audiences-section"
    >
      <div className="max-w-[1700px] mx-auto px-6 sm:px-10 lg:px-12">
        <div className="grid grid-cols-12 gap-6 mb-24">
          <div className="col-span-12 md:col-span-3 t-mono text-[#7A7A78]">
            — § 06 / Built for private clients
          </div>
          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 1.2, ease }}
            className="col-span-12 md:col-span-9 t-display text-[#F4F2EC] text-3xl sm:text-4xl lg:text-5xl leading-[1] tracking-[-0.035em] max-w-3xl"
          >
            Designed for those <span className="text-[#BFBDB6]">who expect more.</span>
          </motion.h3>
        </div>

        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-3 t-mono text-[#7A7A78] hidden md:block">
            Three voices
          </div>
          <div className="col-span-12 md:col-span-9 border-t border-[#1F2126]">
            {audiences.map((a, i) => (
              <motion.div
                key={a.n}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10% 0px" }}
                transition={{ duration: 0.9, ease, delay: i * 0.08 }}
                className="grid grid-cols-12 items-baseline py-10 gap-6 border-b border-[#1F2126]"
                data-testid={`audience-card-${a.n}`}
              >
                <span className="col-span-2 t-mono text-[#7A7A78]">{a.n}</span>
                <span className="col-span-10 md:col-span-4 t-display text-[#F4F2EC] text-2xl sm:text-3xl tracking-[-0.03em] font-light">
                  {a.label}
                </span>
                <span className="col-span-12 md:col-span-6 t-body text-sm text-[#BFBDB6] leading-relaxed">
                  {a.body}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
